import { $inject, $type } from '../utils/di-container.js';
import { UrlService } from "./url.service";
import { insertAfter } from "../utils/dom-utils";
import { MetadataService } from "./metadata.service";
import { FeatureService } from "./feature.service";

/**
 * Service used to apply badge-related CSS on the retailer website.
 */
export class CssService {

  /** @type {HTMLStyleElement} */
  _customCssEl;

  /** @type {UrlService} */
  _urlService;

  /** @type {MetadataService} */
  _metaService;

  /** @type {FeatureService} */
  _featService;

  [$inject](obtain) {
    this._urlService = obtain(UrlService);
    this._metaService = obtain(MetadataService);
    this._featService = obtain(FeatureService);
  }

  /**
   * @param {Badge} badge
   * @returns {Promise<unknown>}
   */
  async importBadgeStyle(badge){
    await new Promise(resolve => {
      const linkElement = document.createElement('link');
      linkElement.type = "text/css";
      linkElement.rel = "stylesheet";
      linkElement.href = this._urlService.styleUrl;
      // wait for stylesheet to actually fully load, before resolving
      linkElement.addEventListener('load', () => resolve());
      badge.shadow.appendChild(linkElement);
    });

    // actually display the badge content only after the style is loaded
    if (badge.isActiveOrActivating()) {
      badge.element.style.display = 'initial';
    }
  };

  async applyCustomStyle() {
    if (this._featService.isEnabled('AA-7595_custom_css_per_retailer')) {
      if (this._customCssEl) {
        this._customCssEl.remove();
      }
      const customCss = this._metaService._badgeInfo?.globalConfiguration?.customCss;
      if (customCss && this._metaService?._badgeMeta && this._metaService._metaElement) {
        this._customCssEl = document.createElement('style');
        this._customCssEl.setAttribute('data-authorizedby-custom-css', '');
        this._customCssEl.innerText = customCss;
        insertAfter(this._metaService._metaElement, this._customCssEl);
      }
    }
  }

}

CssService[$type] = Symbol('CssService');
